var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeatMap5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 82,
    viewBox: "0 0 94 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_f_1693_26305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.129 14.1051C47.107 12.7684 39.9362 17.4785 37.3535 20.0007C27.3649 17.131 18.9928 21.0412 16.0553 23.3551C8.98274 32.4833 5.90252 30.3761 6.21848 47.2172C10.3344 62.289 42.1133 69.1082 64.1623 71.3958C76.2821 67.1198 80.9127 59.7538 83.3102 54.6752C89.226 42.3596 86.981 35.3291 84.8033 32.0648C80.5567 22.663 72.8102 18.75 67.7936 18.7688C64.7002 15.4524 58.0616 14.2779 55.129 14.1051Z",
    fill: "#499FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1366 18.1281C47.0421 16.9748 40.6638 21.2577 38.3615 23.5433C29.5352 21.0226 22.0983 24.5931 19.4831 26.6935C11.628 31.8826 8.42893 41.9381 7.81128 46.3172C4.16702 60.3525 40.5157 71.4629 61.7811 69.6287C73.0711 69.1843 80.2019 59.903 82.3561 55.318C87.6701 44.1985 85.1825 35.5704 83.2745 32.6463C79.5725 24.2117 69.7632 22.1989 65.3212 22.2468C62.6028 19.2815 56.7321 18.2655 54.1366 18.1281Z",
    fill: "#30CB87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0952 31.5364C33.3996 32.1564 31.265 33.2803 30.4097 33.7647C29.0374 33.9333 26.9623 35.7144 26.0962 36.5838C22.143 42.0317 21.544 46.5742 21.6405 48.6838C20.6885 54.3999 36.0931 61.3806 44.956 57.2696L49.3142 58.0319L53.4371 57.8649C62.4567 61.5493 67.9011 55.6078 70.1741 52.8152C75.1464 44.4702 73.5441 39.5157 71.3133 36.3824C65.5942 29.1431 59.6324 29.5967 56.1924 30.8145L53.1655 31.3851L47.1649 31.3143L40.9908 31.8925L35.0952 31.5364Z",
    fill: "#FFC909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9972 34.8654C46.792 34.8901 43.7025 37.1974 42.5584 38.348C39.967 35.1408 35.3917 35.1631 33.4279 35.5751C27.5154 36.1224 25.0488 43.4488 24.5547 47.0437C24.1988 53.9859 31.8074 56.6349 35.6561 57.0916L37.9112 56.4812L40.1178 56.1804L44.364 55.3207L45.663 54.8167L49.5298 54.2758C52.4002 56.0139 56.8428 54.6328 58.7053 53.725C63.2898 54.3653 66.2507 52.4429 67.1581 51.4017C72.1959 46.9695 70.1483 41.3253 68.4947 39.0572C65.4344 34.4198 60.5801 34.287 58.5354 34.8003C54.1304 33.3878 51.0079 34.2551 49.9972 34.8654Z",
    fill: "#FF2F1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1693_26305",
    x: 2.19629,
    y: 9.87109,
    width: 88.9023,
    height: 65.5244,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_1693_26305"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatMap5);
export default __webpack_public_path__ + "static/media/heatMap5.59b5fe05b0ed82bda55a062fc6004de7.svg";
export { ForwardRef as ReactComponent };